<script setup>
import { reactive } from "vue";
import { Icon } from "@iconify/vue";
import { useElements } from "../../../composables/elements";
import { mapActions } from "vuex";

const { errors, elements, reorderElement } = useElements();

const props = defineProps({
  pageId: { type: Number, required: true },
  current: { type: Object, required: true },
  prev: { type: Object, required: true },
  next: { type: Object, required: true },
});

const handleReorder = async (pageId, current, neighbour) => {
  await reorderElement(pageId, current, neighbour);
};
</script>
<template>
  <div class="reorder-buttons">
    <div class="up-btn" v-if="typeof props.prev !== 'undefined'">
      <Icon
        icon="bi:arrow-up-circle"
        id="element-move-up-btn"
        :width="48"
        @click="handleReorder(props.pageId, props.current, props.prev, 'up')"
      />
    </div>
    <div class="down-btn" v-if="typeof props.next !== 'undefined'">
      <Icon
        icon="bi:arrow-down-circle"
        id="element-move-down-btn"
        :width="48"
        @click="handleReorder(props.pageId, props.current, props.next, 'down')"
      />
    </div>
  </div>
</template>

<style lang="scss">
.reorder-buttons {
  .up-btn,
  .down-btn {
    margin-top: -16px;
    position: absolute;
    top: 50%;
    background: #fff;
    border-radius: 50%;
    z-index: 500;
  }

  .up-btn {
    left: 0;
  }

  .down-btn {
    right: 0;
  }
}
</style>
